import { Pagination } from '~services/pagination';
import fetchAllPages from '~utils/fetchAllPages';

type RutterPageFetcher<T> = (
  pagination: Pagination,
) => Promise<{ data: T[]; pagination: Pagination } | null>;

export default function fetchAllRutterPages<T>(
  fetchPage: RutterPageFetcher<T>,
  { signal }: { signal?: AbortSignal } = {},
) {
  return fetchAllPages<T>(
    async (cursor, limit) => {
      const response = await fetchPage({
        limit,
        page: 1,
        ...(cursor ? { after: cursor } : {}),
      });

      // the useRutter getters toast + swallow errors and return null; surface the
      // failure to react-query so the caller can fall back
      if (!response) {
        throw new Error('failed to fetch a page');
      }

      return response;
    },
    { signal },
  );
}
